import React from 'react';
import './index.less';

/**
 * globalDataKeys: [
              'product.subject',
              'extend.promoConfig',
            ],
 */
export default function ProductTitle(props: TitleType.Root) {
  const { subject, promoConfig } = props;

  //  大促预热相关
  const promotionAtmosphere = () => {
    //在extendData里的大促预热
    const promotionInfo = promoConfig && JSON.parse(promoConfig);
    if (promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE?.length > 0) {
      return <img src={promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE[0]?.materialJSON?.image} />;
    } else {
      return null;
    }
  };

  return (
    <div className="product-title-container">
      {/* 标题 */} {/* 大促标 */}
      <h1 title={subject}>
        {promotionAtmosphere()}
        {subject}
      </h1>
    </div>
  );
}
